<template>
  <div class="app-container">
    <nav class="add-navigation">
      <div
        @click="$router.push({ name: 'system-admin-dids-all-dids' })"
        class="back-link"
      >
        <svg
          class="icon"
          width="30px"
          height="30px"
          viewBox="0 0 30 30"
          version="1.1"
        >
          <path
            d="M9.82106781,14.25 L23,14.25 L23,16.25 L9.84421387,16.25 L11.6568542,18.0626404 L10.2426407,19.4768539 L7.41842728,16.6526405 L7.41421356,16.6568542 L7.00735931,16.25 L7,16.25 L7,16.2426407 L6,15.2426407 L6.00421371,15.238427 L6,15.2342133 L7.41421356,13.8199997 L7.41842728,13.8242134 L10.2426407,11 L11.6568542,12.4142136 L9.82106781,14.25 Z"
            id="path-1"
          ></path>
        </svg>
        <p>Back to DID</p>
      </div>
      <div class="buttons-wrapper">
        <div
          @click="$router.push({ name: 'system-admin-dids-all-dids' })"
          class="secondary-button"
        >
          <secondary-button>Cancel</secondary-button>
        </div>
        <div class="primary-button">
          <primary-button @click.native="editDid">Save DID</primary-button>
        </div>
      </div>
    </nav>
    <loader :loading="loading" v-if="loading" />
    <div v-else class="add-container">
      <span class="container-title">Edit DID</span>
      <div class="col-wrapper">
        <div class="col">
          <primary-select
            type="text"
            name="company"
            v-model="did.company_uuid"
            :class="{ input: true, 'is-danger': errors.has('company') }"
            placeholder="Select company"
            :options="companies"
          />
          <div class="col-wrapper">
            <primary-input
              type="text"
              name="did"
              v-model="did.did"
              :class="{ input: true, 'is-danger': errors.has('did') }"
              placeholder="Did"
            />
            <div class="help is-danger" v-if="errors.has('did')">
              {{ errors.first("did") }}
            </div>
            <div class="help is-danger" v-if="contactError">
              {{ contactError.name ? contactError.name : null }}
            </div>
          </div>
        </div>
        <div class="col">
          <primary-select
            type="text"
            name="vendor"
            v-model="did.vendor_uuid"
            :class="{ input: true, 'is-danger': errors.has('vendor') }"
            :options="vendors"
          >
          </primary-select>
          <div class="list primary-input-container multiselect row-second">
            <primary-select
              type="text"
              name="did type"
              v-model="did.did_type"
              v-validate="'required'"
              :class="{ input: true, 'is-danger': errors.has('did type') }"
              :options="did_types"
            />
            <!-- <p class="pimary-input-title">Company</p>
            <multiselect
              v-model="selectedCompany"
              :options="allcompanies"
              :value="allcompanies"
              :multiple="false"
              :close-on-select="true"
              :clear-on-select="true"
              :preserve-search="true"
              placeholder="Pick Company"
              label="company_name"
              track-by="company_uuid"
              :preselect-first="true"
            >
              <template
                slot="selection"
                slot-scope="{ values, search, isOpen, option }"
              >
                <span
                  class="multiselect__single"
                  v-if="values.length &amp;&amp; !isOpen"
                  >{{ values.length }} selected</span
                >
              </template>
            </multiselect> -->
          </div>
          <div class="help is-danger" v-if="errors.has('did type')">
            {{ errors.first("did type") }}
          </div>
          <div class="help is-danger" v-if="contactError">
            {{ contactError.company ? contactError.company : null }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    PrimaryInput: () => import("@/components/Inputs/PrimaryInput.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
    Loader: () => import("@/components/Loader.vue"),
  },
  data: () => ({
    loading: true,
    contactError: null,
    did: null,
    companies: [],
    vendors: [],
    did_types: [
      { name: "ANI", value: "ANI" },
      { name: "DNIS", value: "DNIS" },
    ],
  }),
  created() {
    this.FirstCallApi()
  },
  methods: {
    async FirstCallApi() {
      this.loading = true
      const company1 = await this.$store.dispatch("GetCompanyList", {})
      const vendor1 = await this.$store.dispatch("GetVendorList", {})
      const company2 = this.$store.dispatch("GetCompanyList", { per_page: company1.total })
      const vendor2 = this.$store.dispatch("GetVendorList", { per_page: vendor1.total })
      const did_call = this.$store.dispatch("GetSearchedDid", this.$route.params.id)
      Promise.all([company2, vendor2, did_call])
      .then(res => {
        this.companies = [
          { name: "Select Company", value: null },
          ...res[0].items.map(this.transformCompany),
        ];
        this.vendors = [
          { name: "Select Vendor", value: null },
          ...res[1].items.map(this.transformVendor),
        ];
        const { did, did_type, company_uuid, company_name, vendor_uuid, vendor_name } = res[2]
        this.did = { did_type, did, vendor_uuid, company_uuid };
      })
      .catch(err => {
        this.$snotify.error('Getting error', {
          timeout: 6000
        })
      })
      .finally(() => this.loading = false)
    },
    editDid() {
      this.$validator.validate().then((result) => {
        if (result) {
          this.$store
            .dispatch("EditDid", {
              did: this.$route.params.id,
              newDid: this.did,
            })
            .then((res) => {
              this.$snotify.success("DID have beed edited.", {
                timeout: 6000,
              });
              this.$router.push({ name: "system-admin-dids-all-dids" });
            })
            .catch((err) => {
              if (err.errors) {
                this.contactError = err.errors[0].contact
                  ? err.errors[0].contact
                  : null;
                setTimeout(() => {
                  this.contactError = null;
                }, 6000);
              } else {
                this.$snotify.error(err.error.message, {
                  timeout: 6000,
                });
              }
            });
        }
      });
    },
    transformCompany(item) {
      return {
        name: item.company_name,
        value: item.company_uuid,
      };
    },
    transformVendor(item) {
      return {
        name: item.vendor_name,
        value: item.vendor_uuid,
      };
    },
  },
};
</script>

<style lang="scss" >
.app-container {
  font-family: "Helvetica Neue";
  padding: 0 20px;
  .add-navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    width: 100%;
    margin-top: 20px;
    margin-bottom: 20px;
    .back-link {
      cursor: pointer;
      display: flex;
      align-items: center;
      fill: #51a3f3;
      color: #51a3f3;
      font-family: "Helvetica Neue";
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      p {
        margin-bottom: 0;
      }
    }
    .buttons-wrapper {
      display: flex;
      align-items: center;
      width: fit-content;
      .primary-button {
        height: 40px;
        width: 110px;
      }
      .secondary-button {
        height: 40px;
        width: 90px;
        margin-right: 20px;
      }
    }
  }
  .add-container {
    flex-direction: column;
    align-items: center;
    height: 375px;
    background-color: #ffffff;
    padding-left: 15px;
    padding-top: 15px;
    .container-title {
      height: 30px;
      width: 432px;
      color: #000000;
      font-size: 18px;
      font-weight: 500;
      line-height: 30px;
      padding: 15px 0 15px 0;
    }
    .col-wrapper {
      width: 100%;
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
      .col {
        width: 100%;
        padding-right: 15px;
        padding-left: 0;
        .input {
          margin-bottom: 20px;
        }
        .pimary-input-title {
          color: #000000;
          font-family: "" Helvetica Neue "";
          font-size: 12px;
          font-weight: 300;
          letter-spacing: 0.21px;
          line-height: 15px;
          margin-bottom: 5px;
          text-transform: uppercase;
        }
        .amount {
          font-size: 24px;
        }
      }
      .month {
        padding-right: 0;
      }
    }
    .email-input {
      margin-bottom: 20px;
    }
    .password-input {
      margin-bottom: 30px;
    }
    .first {
      margin-bottom: 30px;
      .remember-me {
        display: flex;
        align-items: center;
        input {
          margin-right: 5px;
        }
      }
    }
  }
}
</style>

